var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLogoPoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 36.802,
    viewBox: "0 0 80 36.802",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-224 -86.916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.794,12.658H139.329L147.471,1.97h51.465Z",
    transform: "translate(105.064 84.947)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.669,25.408H119.2l8.142-10.688h51.465Z",
    transform: "translate(104.796 85.254)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.544,38.158H126.079l8.142-10.688h51.465Z",
    transform: "translate(105.004 85.56)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogoPoor);
export default __webpack_public_path__ + "static/media/white-logo-poor.ca0947d190b4f9efa5e8e096a8f94ae1.svg";
export { ForwardRef as ReactComponent };